'use strict';
import EntityClassRequest from '../../model/entity-class-request';
import { Relation } from '../../model/data-model/data-model-base-objects';

MxMultiObjectRelationPickerCtrl.$inject = [
	'$scope',
	'$q',
	'$element',
	'$timeout',
	'mx.SolutionBuilderAgent.EntityService',
	'mx.internationalization',
	'mx.SolutionBuilderAgent.DialogOpenerService',
	'mx.SolutionBuilderAgent.mxColumnDefinitionService',
	'mx.SolutionBuilderAgent.ExternalServiceManager',
	'mx.shell.KeyboardNavigationService',
	'mx.SolutionBuilderAgent.ContentWidgetService',
	'$attrs',
];
export default function MxMultiObjectRelationPickerCtrl(
	$scope,
	$q,
	$element,
	$timeout,
	mxEntityService,
	i18n,
	dialogOpener,
	columnDefinition,
	externalServiceManager,
	keyboardNavigationService,
	contentWidgetService,
	$attrs
) {
	var vm = this;
	var _intModel;
	var _updatedValues = { addedRelations: [], removedRelations: [] };
	var initialized;

	vm.$onInit = function () {
		vm.test = 'NOT LOADED';
		vm.selectedItems = [];
		vm.originalModel = [];

		_intModel = null;
		Object.defineProperty(vm, '_intModel', {
			get: function () {
				return _intModel;
			},
			set: function (value) {
				_intModel = value;
				vm.selectedIds = value;
				setInitModel();
			},
		});

		mx.SolutionBuilderAgent.ObjectPickerCtrl.call(
			vm,
			$scope,
			$q,
			$element,
			$timeout,
			mxEntityService,
			i18n,
			dialogOpener,
			columnDefinition,
			externalServiceManager,
			keyboardNavigationService,
			contentWidgetService,
			$attrs
		);

		vm.isMultipleSelection = true;
		vm.reverseRelationIsSet = true;
		if (vm.model instanceof Relation) {
			updateRelationConfig(vm.model);
		}

		//init the base class
		vm.$onInit();

		// Redefine default method
		vm.setAdditionalOutputs = function () {};

		initialized = true;

		loadRelationsItems(vm, mxEntityService);
	};

	function updateRelationConfig(relation) {
		var updated = relation !== vm._relation;
		vm._relation = relation;
		vm.relationName = relation.relationsConfig.attributeTo;
		vm.entityClassName = relation.relationsConfig.referenceTo;

		return updated;
	}

	function setInitModel() {
		var added = [],
			removed = [];

		if (vm.originalModel.length === 0) {
			added = _intModel;
		} else if (!_intModel) {
			removed = vm.originalModel;
		} else if (_intModel) {
			_intModel.forEach(function (id) {
				if (vm.originalModel.indexOf(id) < 0) {
					added.push(id);
				}
			});

			vm.originalModel.forEach(function (id) {
				if (_intModel.indexOf(id) < 0) {
					removed.push(id);
				}
			});
		}

		_updatedValues.addedRelations = added || [];
		_updatedValues.removedRelations = removed || [];
		if (vm.model instanceof Relation) {
			const updated = replaceElements(vm.model.removedRelations, _updatedValues.removedRelations);
			if (replaceElements(vm.model.addedRelations, _updatedValues.addedRelations) || updated) {
				loadRelationsItems(vm, mxEntityService);
			}
		}
	}

	function hasEqualItems(array1, array2) {
		return (
			array1.length === array2.length &&
			array1.every(function (value) {
				return array2.indexOf(value) >= 0;
			})
		);
	}

	$scope.$watch(
		'vm.model',
		function () {
			if (!initialized || !(vm.model instanceof Relation)) {
				return;
			}
			var updated = updateRelationConfig(vm.model);
			updated = replaceElements(_updatedValues.removedRelations, vm.model.removedRelations) || updated;
			if (replaceElements(_updatedValues.addedRelations, vm.model.addedRelations) || updated) {
				loadRelationsItems(vm, mxEntityService);
			}
		},
		true
	);

	function replaceElements(array, replacementItems) {
		if (!hasEqualItems(array, replacementItems)) {
			[].splice.apply(array, [0, array.length].concat(replacementItems));
			return true;
		}
	}

	vm.getModel = function () {
		return _intModel;
	};

	function loadAddedItemsDescriptor() {
		if (vm.model instanceof Relation) {
			return $q.all(
				vm.model.addedRelations.map(function (id) {
					return vm._getFragmentDescriptorsInBatch(vm.model.relationsConfig.referenceTo, id, undefined, undefined, undefined, undefined, undefined, vm.columnDefinition);
				})
			);
		}
		return $q.when([]);
	}

	function loadObjectItemsDescriptor() {
		if (vm.model instanceof Relation && vm.model.fragmentId) {
			var requestData = new EntityClassRequest(vm.model.relationsConfig.referenceFrom, undefined, undefined, vm.columnDefinition);
			var extraData = {};

			requestData.allowedTypes = vm.allowedTypes;
			requestData.parent = vm.parentExpression;
			requestData.relationName = vm.model.relationsConfig.attributeFrom;
			requestData.displayExpression = vm.displayExpression;
			requestData.fragmentId = vm.model.fragmentId;
			return mxEntityService.getFragmentDescriptors(requestData, null, extraData);
		}
		return $q.when([]);
	}

	function loadRelationsItems(vm) {
		// Load items by relation
		return $q.all([loadObjectItemsDescriptor(), loadAddedItemsDescriptor()]).then(function (result) {
			var objectItems = result[0],
				allItems = objectItems.concat(result[1]);
			vm.selectedItems = allItems.filter(function (item) {
				return !vm.model.removedRelations || vm.model.removedRelations.indexOf(item.Id) < 0;
			});
			vm.originalModel = objectItems.map(function (item) {
				return item.Id;
			});
			var newIds = vm.selectedItems.map(function (item) {
				return item.Id;
			});
			if (!mx.components.Utils.arraysEqual(newIds, vm._intModel)) {
				vm._intModel = newIds;
			}
		});
	}
}

angular.module('mx.SolutionBuilderAgent').directive('mxMultiObjectRelationPicker', [
	function mxMultiObjectRelationPickerDirective() {
		var directive = mx.SolutionBuilderAgent.ObjectPicker.getDirectiveDescriptor(
			MxMultiObjectRelationPickerCtrl,
			'mx-multi-picker',
			' ng-model="vm._intModel" data-selected-items="vm.selectedItems" '
		);

		angular.extend(directive.bindToController, mx.SolutionBuilderAgent.ObjectPicker.commonObjectPickerProperties);
		delete directive.bindToController.entityClassName;
		directive.bindToController.selectedItems = '=?';
		directive.bindToController.selectedIds = '=?';
		return directive;
	},
]);
